import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {BasicDisplayConsentContainerComponent} from './container/basic-display-consent-container.component';
import {SharedModule} from '@shared/shared.module';
import {DisplayConsentModule} from '../display-consent/display-consent.module';
import {BasicDisplayConsentFooterComponent} from './components/basic-display-consent-footer/basic-display-consent-footer.component';
import {BasicDisplayConsentHeaderComponent} from './components/basic-display-consent-header/basic-display-consent-header.component';
import {TranslateModule} from '@ngx-translate/core';
import {BasicDisplayConsentTextComponent} from './components/basic-display-consent-text/basic-display-consent-text.component';
import {MatIconModule} from '@angular/material/icon';

const routes: Routes = [
    {path: 'basic/:consentId', component: BasicDisplayConsentContainerComponent}
];

@NgModule({
    declarations: [
        BasicDisplayConsentContainerComponent,
        BasicDisplayConsentFooterComponent,
        BasicDisplayConsentHeaderComponent,
        BasicDisplayConsentTextComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        SharedModule,
        DisplayConsentModule,
        TranslateModule,
        MatIconModule
    ]
})
export class BasicDisplayConsentModule {
}
